import React from 'react';

function Testimonials() {
  const testimonials = [
    {
      comment: `"SchoolLine transformed our school's operations. It's user-friendly and highly efficient!"`,
      name: `John Doe`,
      role: `Principal`,
      school: `ABC School`
    },
    {
      comment: `"Efficient, easy-to-use, and feature-rich! A must-have for modern schools."`,
      name: `Jane Smith`,
      role: `Teacher`,
      school: `MNC School`
    },
    {
      comment: `"Managing fees, exams, and attendance has never been easier. Highly recommended!"`,
      name: `Michael Brown`,
      role: `Administrator`,
      school: `MNC School`
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-800 via-gray-900 to-black text-gray-300">
      <h2 className="text-2xl font-bold text-center mt-10 mb-10 sm:mb-7 text-gray-200">
        What Our Clients Say</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-8">
        {testimonials.map((test, index) => (
          <div
            key={index}
            className="bg-gray-700 p-6 rounded-3xl shadow-md hover:shadow-lg transition-transform duration-700 transform hover:scale-105"
          >
            <p className="text-lg italic mb-4 text-gray-400">
              {test.comment}
            </p>
            <p className="text-right font-bold text-primaryColor">- {test.name}, {test.role}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;